import moment from "moment";

const getDays = () => {
    const days = [];

    for (let i = 1; i <= 31; i++) {
        days.push(i)
    }

    return days;
}

const getMonths = () => {
    return Array.from({length: 12}, (e, i) => {
        let numberMonth = i + 1
        return {
            code: numberMonth,
            label: new Date(null, numberMonth, null).toLocaleDateString("en", {month: "long"})
        }
    })
}

const getYears = (diffYear = 70) => {
    const now = new Date().getFullYear()
    return Array(now - (now - diffYear)).fill('').map((v, idx) => now - idx);
}

const getDateFormat = (date, format = 'YYYY-MM-DD') => {
    try {
        const m = moment(String(date), format)
        return m.isValid() ? m.format(format) : null
    } catch (e) {
        return null
    }
}

export default {
    getDays,
    getMonths,
    getYears,
    getDateFormat
}
